module.exports = ":host .back-home {\n  margin-top: 5.125rem; }\n  :host .back-home button {\n    color: #fff;\n    font-weight: 700;\n    opacity: 0.5;\n    letter-spacing: -0.1px;\n    background: transparent; }\n  :host .back-home button i {\n      font-size: 0.75rem; }\n  @media screen and (min-width: 1024px) {\n  :host .search-info {\n    margin-bottom: 1.625rem !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/search/search.component.scss
// module id = ./src/app/views/search/search.component.scss
// module chunks = main